// extracted by mini-css-extract-plugin
module.exports = {"uk-miniHome":"style_uk-miniHome__QuH3S","homeContainer":"style_homeContainer__xjQH_","tab":"style_tab__ZRHXC"};